import axiosApiConfig from '@/axiosApiConfig';
import ECurrency from '@/enums/ECurrency';

interface ICurrencyRate {
  date: string;
  rate: number;
}

const getCurrencyRate = async (data: {
  from: ECurrency;
  to: ECurrency;
}): Promise<ICurrencyRate> => {
  const result= await axiosApiConfig.post('/currency_rates', data);

  return result.data;
};

export default getCurrencyRate;


